import { getS3Url } from '@/libs/utils'
import UiTooltip from '@/components/ui/UiTooltip'

export default {
  components: {
    UiTooltip
  },
  props: [
    'itemIndex',
    'item',
    'isFirstItem',
    'isLastItem',
    'pathItem',
    'dataType',
    'countData'
  ],
  computed: {
    sessionCount () {
      return this.countData[this.dataType]
    },
    inflow () {
      return this.item.inflow[this.dataType]
    },
    dropped () {
      return this.item.dropped[this.dataType]
    },
    dropOff () {
      return this.item.dropOff[this.dataType]
    },
    dropOffRate () {
      return this.item.dropOffRate[this.dataType]
    },
    remain () {
      return this.item.remain[this.dataType]
    },
    newPercentageStyle () {
      if (this.item.newLabelPercentage) {
        const top = this.item.newLabelPercentage
        return {
          top: `${top}%`
        }
      }
      return null
    },
    revisitPercentageStyle () {
      if (this.item.revisitLabelPercentage) {
        const top = this.item.revisitLabelPercentage
        return {
          top: `${top}%`
        }
      }
      return null
    },
    dropOffIconClass () {
      if (this.dropOffRate >= 30) {
        return 'icon--arrow_l'
      } else if (this.dropOffRate >= 10) {
        return 'icon--arrow_m'
      } else {
        return 'icon--arrow_s'
      }
    },
    isExactMatchType () {
      return this.item.matchType === 'exact'
    },
    thumbImageStyle () {
      const thumbImageUrl = getS3Url(this.item.thumbImagePath)

      return {
        backgroundImage: thumbImageUrl ? `url(${thumbImageUrl})` : null
      }
    }
  },
  methods: {
    onConversionClick (item, isDropped, isConverted) {
      this.$emit('onConversionClick', item, isDropped, isConverted)
    },
    onShowFlowClick (item) {
      this.$emit('onShowFlowClick', item)
    }
  }
}
